import type { CountyResponse } from '@/types'

interface CountiesApiResponse {
  success: boolean
  data: CountyResponse[]
}

export function useCounties() {
  return useAsyncData<CountiesApiResponse>(
    'counties',
    () => $fetch('/api/counties')
  )
}

export function useCounty(slug: string | Ref<string>) {
  const slugRef = isRef(slug) ? slug : ref(slug)

  const { data: countiesData, pending, error, refresh, execute } = useCounties()

  const county = computed<CountyResponse | null>(() => {
    if (!countiesData.value?.data) return null
    return countiesData.value.data.find((c) => c.slug === slugRef.value) ?? null
  })

  return {
    data: county,
    pending,
    error,
    refresh,
    execute,
  }
}
